module.exports = __webpack_public_path__ + "static/media/math-day-pos.1895952e.png";